import { USER_ERR_MESSAGES } from "@bakbak/common";
import {
  GetPostDetailsByIdQuery_getPostDetailsById,
  IWithPostVoteChange,
  PostDetailsController,
  withPostVoteChange
} from "@bakbak/controller";
import * as React from "react";
import { AppContextProps, withAppContext } from "../../../context/AppContext";
import { CreateCommentConnector } from "../../comment/create/CreateCommentConnector";
import { CommentFilterView } from "../../comment/filter/CommentFilterView";
import { loginRegisterAlert } from "../../shared/LoginRegisterAlert";
import { PostDetailsHeaderView } from "./PostDetailsHeaderView";

interface Props {
  postId: string;
}

class PostDetailsHeaderC extends React.PureComponent<
  Props & IWithPostVoteChange & AppContextProps
> {
  postVoteChange = async (
    likeDislike: number,
    post: GetPostDetailsByIdQuery_getPostDetailsById
  ) => {
    const { postVoteChange, postId, context } = this.props;

    if (context.loggedUser) {
      const response = await postVoteChange(
        { postId, likeDislike },
        post,
        context.loggedUser
      );
      if (response && response.errors) {
        if (
          response.errors[USER_ERR_MESSAGES.LOGIN_OR_REGISTER] ===
          USER_ERR_MESSAGES.LOGIN_OR_REGISTER
        ) {
          loginRegisterAlert();
        } else {
          console.log(
            "some error occured. Please log it properly",
            response.errors
          );
        }
      }
    } else {
      loginRegisterAlert();
    }
  };

  toggleLiveComments = (checked: any) => {
    console.log(`switch to ${checked}`);
  };

  // TODO: change the post details to contain ComentCount
  renderTotalComments = (commentsCount: number) => {
    const { context, postId } = this.props;
    return (
      <div style={{ flex: 2, flexDirection: "column", marginTop: 15 }}>
        <span style={{ flex: 2, flexDirection: "row" }}>
          <span style={{ marginLeft: 50, marginRight: 50, fontSize: "1.2em" }}>
            {commentsCount} Comments
          </span>
          <CommentFilterView />
          {/* <Switch style={{ marginLeft: 150, backgroundColor: THEME_COLOR }} 
						defaultChecked={true} onChange={this.toggleLiveComments} /> */}
        </span>
        <CreateCommentConnector
          postId={postId}
          loggedUser={context.loggedUser}
        />
      </div>
    );
  };

  render() {
    const { postId, context } = this.props;
    return (
      <div>
        <PostDetailsController postId={postId}>
          {data => {
            const { postDetails, postDetailsLoading } = data;
            if (postDetailsLoading || !postDetails) {
              return <div>...loading</div>;
            }
            return (
              <div>
                <PostDetailsHeaderView
                  post={postDetails}
                  loggedUser={context.loggedUser}
                  postVoteChange={this.postVoteChange}
                />
                {this.renderTotalComments(postDetails.commentCount)}
              </div>
            );
          }}
        </PostDetailsController>
      </div>
    );
  }
}

export const PostDetailsHeaderConnector = withPostVoteChange(
  withAppContext(PostDetailsHeaderC)
);



// WEBPACK FOOTER //
// ./src/modules/post/details/PostDetailsHeaderConnector.tsx